/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'

const AboutLazyRouteImport = createFileRoute('/about')()
const ChartsLazyRouteImport = createFileRoute('/charts')()
const ContactLazyRouteImport = createFileRoute('/contact')()
const ExplorerLazyRouteImport = createFileRoute('/explorer')()
const LeaderboardLazyRouteImport = createFileRoute('/leaderboard')()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutLazyRoute = AboutLazyRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))
const ChartsLazyRoute = ChartsLazyRouteImport.update({
  id: '/charts',
  path: '/charts',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/charts.lazy').then((d) => d.Route))
const ContactLazyRoute = ContactLazyRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/contact.lazy').then((d) => d.Route))
const ExplorerLazyRoute = ExplorerLazyRouteImport.update({
  id: '/explorer',
  path: '/explorer',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/explorer.lazy').then((d) => d.Route))
const LeaderboardLazyRoute = LeaderboardLazyRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/leaderboard.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutLazyRoute
  '/charts': typeof ChartsLazyRoute
  '/contact': typeof ContactLazyRoute
  '/explorer': typeof ExplorerLazyRoute
  '/leaderboard': typeof LeaderboardLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutLazyRoute
  '/charts': typeof ChartsLazyRoute
  '/contact': typeof ContactLazyRoute
  '/explorer': typeof ExplorerLazyRoute
  '/leaderboard': typeof LeaderboardLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutLazyRoute
  '/charts': typeof ChartsLazyRoute
  '/contact': typeof ContactLazyRoute
  '/explorer': typeof ExplorerLazyRoute
  '/leaderboard': typeof LeaderboardLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/about' | '/charts' | '/contact' | '/explorer' | '/leaderboard'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/about' | '/charts' | '/contact' | '/explorer' | '/leaderboard'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/charts'
    | '/contact'
    | '/explorer'
    | '/leaderboard'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutLazyRoute: typeof AboutLazyRoute
  ChartsLazyRoute: typeof ChartsLazyRoute
  ContactLazyRoute: typeof ContactLazyRoute
  ExplorerLazyRoute: typeof ExplorerLazyRoute
  LeaderboardLazyRoute: typeof LeaderboardLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/charts': {
      id: '/charts'
      path: '/charts'
      fullPath: '/charts'
      preLoaderRoute: typeof ChartsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explorer': {
      id: '/explorer'
      path: '/explorer'
      fullPath: '/explorer'
      preLoaderRoute: typeof ExplorerLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutLazyRoute: AboutLazyRoute,
  ChartsLazyRoute: ChartsLazyRoute,
  ContactLazyRoute: ContactLazyRoute,
  ExplorerLazyRoute: ExplorerLazyRoute,
  LeaderboardLazyRoute: LeaderboardLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
